<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          outlined
          label
          small
          :color="plano.status ? plano.status.color : 'primary'"
          dark
          v-bind="attrs"
          v-on="on"
          block
        >
          {{ plano.status?.descricao ?? "Aguardando Confirmação" }}
        </v-btn>
      </template>
      <v-list v-if="permitirRolesParaGestores() >= 0">
        <v-list-item
          v-for="situacao of $constants.situacoesPlanos"
          :key="situacao.descricao"
          link
          @click="() => atualizarSituacao(plano, situacao)"
        >
          <v-list-item-title>
            <v-icon :color="situacao.cor" class="mr-2">mdi-circle</v-icon>
            {{ situacao.descricao ? situacao.descricao : "- - -" }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["plano"],
  computed: {
    ...mapGetters("Auth", ["user"]),
  },
  methods: {
    async atualizarSituacao(plano, situacao) {
      const response = await this.$services.planosAnuaisService.update(plano.id, situacao.id);
      if (response) {
        this.$emit("update", response);
        this.$emit("close-modal");
      }
    },
    permitirRolesParaGestores() {
      try {
        const userLocal = this.user.roles ? this.user.roleName : [];
        return this.$constants.rolesParaGestores.findIndex((elem) => {
          return elem.name === userLocal;
        });
      } catch (error) {
        this.$handleError(error);
      }
      return false;
    },
  },
};
</script>
